import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SiteFooter, SiteHeader, SiteLinkProvider } from "@quintara/site-kit";
import { RouterLink } from "./siteLink";
import { WhatsAppWidget } from "./WhatsAppWidget";

// Scroll to the hash target on navigation, otherwise jump to the top.
// The original multi-page site got this for free from the browser; a SPA
// has to reproduce it on route change.
function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export function Layout() {
  return (
    <>
      <ScrollManager />
      {/* Header, page and footer all navigate via react-router on the website. */}
      <SiteLinkProvider value={RouterLink}>
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
      </SiteLinkProvider>
      <WhatsAppWidget />
    </>
  );
}
